export const isColorDark = (hexColor: string): boolean => {
  if (!hexColor || !hexColor.startsWith('#') || hexColor.length !== 7) return false;

  const r = parseInt(hexColor.substring(1, 3), 16);
  const g = parseInt(hexColor.substring(3, 5), 16);
  const b = parseInt(hexColor.substring(5, 7), 16);

  const brightness = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  return brightness < 128;
};
